import React, { useContext } from 'react'

import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import Badge from '@material-ui/core/Badge'
import { withStyles } from '@material-ui/core/styles'
import { FirestoreContext } from '../../providers/firestore-provider'

const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      backgroundColor: '#44b700',
      color: '#44b700',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        animation: '$ripple 1.2s infinite ease-in-out',
        border: '1px solid currentColor',
        content: '""',
      },
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0,
      },
    },
  })
)(Badge)

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    largeSizeImg: {
      width: theme.spacing(8),
      height: theme.spacing(8),
    },
    avatarContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    userInforConatiner: {
      textAlign: 'center',
      marginTop: '20px',
    },
  })
)

const CurrentUser = () => {
  const classes = useStyles()
  const { currentUser } = useContext(FirestoreContext)
  return (
    <section>
      <Grid container>
        <Grid item xs={12} className={classes.avatarContainer}>
          <StyledBadge
            overlap="circle"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            variant="dot"
          >
            {currentUser?.photoURL ? (
              <Avatar
                alt={currentUser?.displayName || currentUser?.username}
                src={currentUser?.photoURL}
                className={classes.largeSizeImg}
              />
            ) : (
              <Avatar className={classes.largeSizeImg}>
                {currentUser?.displayName?.charAt(0)?.toUpperCase()}
              </Avatar>
            )}
          </StyledBadge>
        </Grid>
        <Grid item xs={12} className={classes.userInforConatiner}>
          <Typography variant="h6">{currentUser?.displayName}</Typography>
          <Typography>{currentUser?.username}</Typography>
        </Grid>
      </Grid>
    </section>
  )
}

export default CurrentUser
